import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../../data/content';

const resolveAssetUrl = (src) => {
  if (!src) return '';
  if (src.startsWith('http://') || src.startsWith('https://')) return src;
  const publicUrl = process.env.PUBLIC_URL || '';
  return `${publicUrl}${src.startsWith('/') ? src : `/${src}`}`;
};

const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

const BlogTwo = () => {
  const posts = useMemo(() => {
    return [...blogPosts].sort((a, b) => {
      const aDate = new Date(a.publishDate || a.updatedDate || 0).getTime();
      const bDate = new Date(b.publishDate || b.updatedDate || 0).getTime();
      return bDate - aDate;
    });
  }, []);

  return (
    <section className="blog-one">
      <div className="container">
        <div className="sec-title text-center">
          <h2 className="sec-title__title">Events & Guides</h2>
          <p className="sec-title__text">Local eats, seasonal produce, and SWFL food finds</p>
        </div>
        <div className="row">
          {posts.map((post, index) => {
            const hero = resolveAssetUrl(post.images?.thumbnail || post.images?.hero);
            return (
              <div
                key={post.slug}
                className="col-xl-4 col-lg-4 wow fadeInUp"
                data-wow-delay={`${(index % 3) * 100}ms`}
              >
                <div className="blog-one__single">
                  <div className="blog-one__single-img">
                    <img
                      src={hero || resolveAssetUrl('/assets/images/blog/blog-v1-img1.jpg')}
                      alt={post.title}
                      onError={(e) => {
                        e.currentTarget.src = resolveAssetUrl('/assets/images/blog/blog-v1-img1.jpg');
                      }}
                    />
                  </div>

                  <div className="blog-one__single-content">
                    <p className="blog-one__single-content-tagline">
                      {post.category || 'Updates'}{post.publishDate ? ` • ${formatDate(post.publishDate)}` : ''}
                    </p>
                    <h2>
                      <Link to={`/events/${post.slug}`}>{post.title}</Link>
                    </h2>
                    <div className="line"></div>
                    <div className="text">
                      <p>{post.excerpt || ''}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BlogTwo;
